import { ResponseAuth } from './interfaces/Response';
import { http } from "../../services/apiAuth/Http.interceptor";
import User from './interfaces/Login';

const URL: string = '/si/cl/v0/auth';

export const authService = (user: User) => {
    return http.post<ResponseAuth>(URL, user)
}